const DESTINATION_QUESTION = {
  CERTIFICATE: "1",
  SCIENTIFIC_PROGRAMMING: "2",
  MY_PROFILE: "3",
  COMPANION: "4",
  CAEX: "5",
  WORKS: "6",
  INDIVIDUAL: "7",
  TITLE_PROOF: "11",
  CAEX_ICONGRESSOLIVE: "12",
  RESIDENCE_SERVICE_EVALUATION: "14",
  EPOSTER_VOTING: "15",
  QUESTIONNAIRE: "16",
  MY_PROFILE_ENTITY: "17",
  APP_VISIT_STANDS: "18",
  APP_QUIZ: "19",
  APP_CASE_STUDY: "20",
  PDG: "21",
  REENROLLMENT: "99"
};

export default { DESTINATION_QUESTION };
